export const STALE_TIME_10_MIN = 10 * 60 * 1000;
